import { render } from "./UICheckBox.vue?vue&type=template&id=3e12646e"
import script from "./UICheckBox.vue?vue&type=script&lang=ts"
export * from "./UICheckBox.vue?vue&type=script&lang=ts"
script.render = render

export default script